import { Form } from "antd";
import { TopBox } from "components";
import { LoadingDashboard } from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardParcelType } from "service/dashboard/central/parcel";

const ParcelType = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();

  const typeParcelDate = Form.useWatch("typeParcelDate");
  const date = findDate(typeParcelDate);

  const query = useGetDashboardParcelType({ ...date, property });

  return (
    <LoadingDashboard loading={query.isFetching}>
      <TopBox
        translation
        query={query}
        keyTitle="name"
        nameDate="typeParcelDate"
        title={t("each-type-of-parcel")}
        isCentral
      />
    </LoadingDashboard>
  );
};

export default ParcelType;
